import axios from "axios";
import { apiDomain } from "../constants"

export const logInAdmin = ({ user }) => {
    return axios.post(`${apiDomain}admin/auth/`, user);
}
